import React, { useState } from "react";
import { FaMinus, FaPlus, FaFileMedical, FaCogs, FaLock, FaKey, FaUserShield, FaDatabase, FaClipboardCheck, FaUserSecret, FaUserCheck, FaEyeSlash } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcareDataSecurity/PatientProtection.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "HIPAA Compliance & Security",
        "description": "Ensures full compliance with HIPAA, GDPR, and other healthcare data protection regulations by implementing strict security policies. Features include role-based access controls (RBAC), end-to-end encryption, and automatic security audits to prevent data breaches. Helps healthcare organizations avoid legal penalties while maintaining patient trust and confidentiality."
    },
    {
        "title": "Data Encryption & Secure Access",
        "description": "Utilizes advanced encryption protocols (AES-256 for data at rest, TLS 1.3 for data in transit) to secure patient health information (PHI) from unauthorized access. Implements robust authentication methods, including multi-factor authentication (MFA) and biometric verification, ensuring only authorized healthcare professionals can access sensitive data."
    },
    {
        "title": "Anonymization & De-Identification",
        "description": "Applies techniques like data masking, tokenization, and homomorphic encryption to remove personally identifiable information (PII) while preserving data utility for research and analytics. Supports compliance with privacy laws, including HIPAA and GDPR, enabling secure data sharing without compromising patient confidentiality."
    },
    {
        "title": "Consent Management",
        "description": "Empowers patients with full control over their medical records through granular data-sharing permissions and blockchain-based consent tracking. Digital consent forms and automated revocation features ensure transparency, allowing patients to grant or withdraw access in real-time while maintaining regulatory compliance."
    },
    {
        "title": "Audit Trails & Activity Monitoring",
        "description": "Maintains tamper-proof logs of all user activities, including data access, modifications, and sharing events. Uses AI-driven anomaly detection to identify unauthorized attempts or suspicious behavior, triggering real-time alerts. Enables regulatory compliance through continuous monitoring and detailed forensic reporting."
    },
    {
        "title": "Secure Telehealth Communication",
        "description": "Implements end-to-end encrypted video consultations, secure messaging, and protected file-sharing for remote healthcare services. Integrates AI-based identity verification and session monitoring to prevent unauthorized access, ensuring compliance with telehealth security standards while enhancing patient-doctor confidentiality."
    }
]

const features = [
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Robust security measures to protect patient confidentiality." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "End-to-end encryption for electronic health records (EHRs)." },
    { icon: <FaEyeSlash className="text-[#2a627a] text-lg" />, text: "Access control to prevent unauthorized data visibility." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Privacy-centric EHR systems for secure medical documentation." },
    { icon: <FaKey className="text-[#2a627a] text-lg" />, text: "Multi-factor authentication (MFA) for secure login." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Regular compliance audits to uphold patient privacy regulations." }
];

const benefits = [
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Prevents unauthorized access to sensitive patient data." },
    { icon: <FaUserSecret className="text-[#2a627a] text-lg" />, text: "Builds patient trust by ensuring data confidentiality." },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Enhances compliance with healthcare privacy laws (HIPAA, GDPR)." },
    { icon: <FaCogs className="text-[#2a627a] text-lg" />, text: "Strengthens healthcare cybersecurity against data breaches." },
    { icon: <FaEyeSlash className="text-[#2a627a] text-lg" />, text: "Minimizes identity theft risks by securing medical records." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Improves data governance through transparent policies and controls." }
];
const cmsFeatures = [
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Privacy Officer – Oversees patient data protection policies." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "Cybersecurity Specialist – Implements encryption and access control." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Compliance Manager – Ensures adherence to HIPAA, GDPR, and other regulations." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Health IT Security Analyst – Monitors system security and prevents breaches." },
    { icon: <FaUserSecret className="text-[#2a627a] text-lg" />, text: "Data Protection Officer – Manages patient consent and privacy rights." },
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "EHR Administrator – Maintains secure access to electronic medical records." }
];

const PPP = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Patient Privacy Protection - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Secure Cloud Storage ensures encrypted data protection, access control, compliance, and reliable backups for safe healthcare data management."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Patient Privacy Protection?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Patient Privacy Protection refers to safeguarding personal health information (PHI) from unauthorized access, breaches, and cyber threats. It ensures that electronic health records (EHRs), telehealth data, and medical histories remain confidential, secure, and compliant with regulations like HIPAA, GDPR, and HITECH.

                            At HIKEHEALTH GS, we implement cutting-edge security measures to protect patient data from cyber risks, unauthorized sharing, and identity theft while maintaining seamless access for healthcare professionals.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Secure Cloud Storage
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default PPP;
